import React, { FC } from 'react'
import { Trans, t } from '@lingui/macro'

import { Modal } from '../../../components/common/modal/Modal'

import { notification } from '../../../components/common/notifications/Notifications'
import { useMarkPathwayAsCompleteMutation } from './PathwayMarkAsComplete.codegen'
import { ButtonClean, ButtonDanger } from 'front-end/src/components'

interface IProps {
  pathwayEnrolmentId: number
  onCanceled: () => void
  onComplete: () => void
}

export const PathwayMarkAsComplete: FC<IProps> = (props: IProps) => {
  const [markAsCompleteMutation, { loading: isMutating }] =
    useMarkPathwayAsCompleteMutation()

  const handleOnComplete = async (): Promise<void> => {
    try {
      await markAsCompleteMutation({
        variables: {
          pathwayEnrolmentId: props.pathwayEnrolmentId
        }
      })
      notification.info(t`Pathway enrolment has been marked as completed`)

      props.onComplete()
    } catch (e) {
      notification.error(t`Error updating pathway enrolment`)
    }
  }

  const renderControls = () => {
    const { onCanceled } = props

    return (
      <>
        <ButtonClean onClick={onCanceled}>
          <Trans>Cancel</Trans>
        </ButtonClean>
        <ButtonDanger isLoading={isMutating} onClick={handleOnComplete}>
          <Trans>Complete enrolment</Trans>
        </ButtonDanger>
      </>
    )
  }

  return (
    <Modal
      header={t`Complete pathway enrolment`}
      show
      controls={renderControls()}
      onHide={props.onCanceled}
    >
      <p>
        <Trans>
          Are you sure you want to mark this pathway enrolment as completed?
          This action cannot be undone.
        </Trans>
      </p>
    </Modal>
  )
}
